
import React, {PropTypes, Component} from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { SetSummary, SetForecastType } from '../../actions';
import RiskFinderComponent from '../RiskFinderComponent';
import * as d3 from 'd3';
import styles from './NuisanceFloodingData.css';
import withStyles from '../../decorators/withStyles';


class NuisanceFloodingData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: {}
    };

    this.margin = {top: 20, right: 20, bottom: 55, left: 75};
    this.width = 660 - this.margin.left - this.margin.right;
    this.height = 350 - this.margin.top - this.margin.bottom;

    this.subtitles = {
      "Multi-year": "Risk of at least one flood from 2016 through each year shown",
      "Single-year": "Risk of at least one flood within each year shown",
      "Basic": "A localized projection",
      "With mild flood": "A \u201Cmild flood\u201D averages once per year",
      "With moderate flood": "A \u201Cmoderate flood\u201D has a roughly 10% chance per year",
      "With extreme flood": "A \u201Cmajor flood\u201D has a roughly 1% chance per year",
    }
  }

  summarizeData() {
    this.props.dispatch(SetSummary(3, {type: "nuissance-flooding",
      data: {}
    }));
  }

  async loadData() {
    var self = this;
    const { place, aslrStation } = this.props;
    if (!place.id) {
      return;
    }

    const urls = [
      `/api/aslr-flooding/flood-days-decade/${aslrStation.id}`,
      `/api/aslr-flooding/flooding-history/${aslrStation.id}`,
      `/api/aslr-flooding/current-water-level/${aslrStation.id}`,
    ];

    const results = await Promise.all(urls.map((url) => d3.json(url)));
    const [ aslrData, history, currWaterLevel ] = results;
    const dateMap = {
      '1960': '1955-64',
      '1970': '1965-74',
      '1980': '1975-84',
      '1990': '1985-94',
      '2000': '1995-2004',
      '2010': '2005-14',
    };
    const aslrPoints = aslrData.slice(1, 7).map(d => {
      return {
        date: dateMap[d['decade']],
        natural_days: d['natural_days'],
        anthro_days: d['anthro_days'],
      }
    });

    self.setState({data: {
      aslrPoints,
      history,
      currWaterLevel
    }}, self.summarizeData);

  }

  update() {
    if (this.hasData()) {
      this.summarizeData();
    }
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(props) {
    if (props.place.id !== this.props.place.id || props.place.type !== this.props.place.type ||
        props.stationNum !== this.props.stationNum) {
      this.loadData();
    }
  }

  hasData() {
    return this.state && this.state.data && Object.keys(this.state.data).length > 0;
  }

  render() {
    if (!this.hasData()) {
      return null;
    }

    return (
      <div className="NuisanceFloodingData main">
        <div>{React.Children.map(this.props.children,
          child => React.cloneElement(child, {
            data: this.state.data,
            station: null,
            ...this.props
          }))}
        </div>
      </div>
    );
  }

}

function selectProps(state) {
  return {
    place: state.place,
    placeName: state.placeName,
    placeContainer: state.placeContainer,
    stationNum: state.stationNum,
    stations: state.stations,
    aslrStation: state.aslrStation,
    aslrPoints: state.aslrPoints,
    modalVisible: state.modalVisible,
    isEmbed: state.isEmbed,
  }
}

export default compose(
  withStyles(styles),
  connect(selectProps),
)(NuisanceFloodingData);
